/**
 * Même logique que AuthPanelCornerDecor (triangles, hypoténuse courbe), version compacte mobile.
 */
const PATH_RED = "M 0 0 L 100 0 Q 32 32 0 100 Z";
const PATH_YELLOW = "M 100 100 L 0 100 Q 68 68 100 0 Z";

export function AuthMobileHeroAccents() {
  const corner = "h-[48px] w-[min(34vw,112px)]";

  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden lg:hidden" aria-hidden>
      <svg
        className={`absolute left-0 top-0 z-0 ${corner} drop-shadow-sm`}
        viewBox="0 0 100 100"
        preserveAspectRatio="none"
      >
        <path fill="#f7040a" d={PATH_RED} />
      </svg>
      <svg
        className={`absolute bottom-0 right-0 z-0 ${corner} drop-shadow-sm`}
        viewBox="0 0 100 100"
        preserveAspectRatio="none"
      >
        <path fill="#F2B531" d={PATH_YELLOW} />
      </svg>
    </div>
  );
}
